import { render, staticRenderFns } from "./PropertyActionGrid.vue?vue&type=template&id=4a04f70c&"
import script from "./PropertyActionGrid.vue?vue&type=script&lang=js&"
export * from "./PropertyActionGrid.vue?vue&type=script&lang=js&"
import style0 from "./PropertyActionGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports